export const sendEvent = event => {
  if (process.env.REACT_APP_API_ENV === 'production') {
    window.hj('event', `${event}`);
  }
};
